import { css, StyleSheet } from 'aphrodite';
import { Separator as SeparatorPrimitive } from 'radix-ui';
import * as React from 'react';
import { aceGray } from '../../styles/colors';

const styleSheet = StyleSheet.create({
	root: {
		flexShrink: 0,
		backgroundColor: aceGray,
	},
	horizontal: {
		height: 1,
		width: '100%',
	},
	vertical: {
		height: '100%',
		width: 1,
	},
});

const Separator = React.forwardRef<
	React.ElementRef<typeof SeparatorPrimitive.Root>,
	AphroditeStyled<React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>>
>(({ styles = [], orientation = 'horizontal', decorative = true, ...props }, ref) => (
	<SeparatorPrimitive.Root
		ref={ref}
		decorative={decorative}
		orientation={orientation}
		className={css(
			styleSheet.root,
			orientation === 'horizontal' ? styleSheet.horizontal : styleSheet.vertical,
			...styles
		)}
		{...props}
	/>
));
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
